import ReactMarkdown from 'react-markdown'

interface Props {
  role: 'user' | 'assistant'
  content: string
  streaming?: boolean
}

export default function ChatMessage({ role, content, streaming }: Props) {
  const isUser = role === 'user'

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      {!isUser && (
        <div className="w-8 h-8 rounded-full bg-[var(--color-accent)]/20 border border-[var(--color-accent)]/30 flex items-center justify-center text-sm mr-2 flex-shrink-0 mt-1">
          🏪
        </div>
      )}
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-3 text-sm leading-relaxed break-words ${
          isUser
            ? 'bg-[var(--color-accent)] text-[var(--color-primary)] font-medium rounded-br-sm'
            : 'bg-[var(--color-surface)] border border-[var(--color-border-default)] text-[var(--color-text-primary)] rounded-bl-sm'
        }`}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap">{content}</p>
        ) : (
          <div className="prose prose-sm max-w-none
            prose-p:text-[var(--color-text-primary)] prose-p:leading-relaxed prose-p:my-1.5
            prose-headings:text-[var(--color-text-primary)] prose-headings:font-bold
            prose-strong:text-[var(--color-accent)] prose-strong:font-semibold
            prose-ul:text-[var(--color-text-primary)] prose-ul:my-1.5 prose-ul:pl-4
            prose-ol:text-[var(--color-text-primary)] prose-ol:my-1.5 prose-ol:pl-4
            prose-li:my-0.5
            prose-code:text-[var(--color-accent)] prose-code:bg-[var(--color-bg)] prose-code:px-1 prose-code:rounded
            prose-blockquote:border-[var(--color-accent)] prose-blockquote:text-[var(--color-text-tertiary)]">
            <ReactMarkdown>{content}</ReactMarkdown>
            {streaming && <span className="inline-block w-1.5 h-4 bg-[var(--color-accent)] animate-pulse ml-0.5 align-middle" />}
          </div>
        )}
      </div>
    </div>
  )
}
